import Footer from "../../components/footer/Footer"
import  Article from "../../components/article/Article"
import Navbar from "../../components/navbar/Navbar"

import styled from "./home.module.css"
import { useEffect, useState } from "react"
import axios from "axios"
import { Link } from "react-router-dom"
function Home(){
    const [articles,setArticles]=useState([]) ;// وقتی تغییر میکند ریرندر میشه 
    const [isLoadung,setIsLoading]=useState(false) 

  
useEffect(() => {
  setIsLoading(true);

  axios.get("/db.json")
    .then((res) => {

      // آرایه مقالات را از فایل می‌گیریم:
      const articles = res.data.articles;

      setArticles(articles);
      setIsLoading(false);
    })
    .catch((err) => {
      console.log(err);
      setIsLoading(false);
    });

}, []);

   
  
return(
<div className={styled.homeWrapper }>
    <Navbar title="سایت عوض نیا" /> 
    <div className="container">
        <h2 >مقالات جدید</h2>
       
          {  isLoadung? (<p>چند لحظه صبر کنین</p>):
       (
        
        <div className={styled.articles}>
            {
                articles.map(article=>( 
                <Link to={`/article/${article.id}`}>
                <Article key={article.id}  article={article}/>
                
                  </Link>
                ))}
              
                </div>  
            )}
       
      
    </div>
    <Footer ></Footer>
        
</div>
);
}
export default Home
